import { render, staticRenderFns } from "./questionMstDetail.vue?vue&type=template&id=77788652"
import script from "./questionMstDetail.vue?vue&type=script&lang=js"
export * from "./questionMstDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77788652')) {
      api.createRecord('77788652', component.options)
    } else {
      api.reload('77788652', component.options)
    }
    module.hot.accept("./questionMstDetail.vue?vue&type=template&id=77788652", function () {
      api.rerender('77788652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/quiz/questionMstDetail.vue"
export default component.exports